import moment from 'moment';
import {
  YES
} from '../../Boolean.lib';
import {
  STATE_ACTIVE,
  STATE_HOLD
} from '../../Definition';
import {
  getCandidateModel
} from '../../models/candidate';

/**
 * Determines whether candidate match exclusion is enabled.
 *
 * @function evalCandidateMatchExclusion
 * @param {Object} candidate - Candidate object to evaluate.
 * @param {number} index - Index of the candidate in the candidates array.
 * @param {Object[]} candidates - Full list of candidates.
 * @returns {boolean} True if candidate can be matched, false if excluded.
 *
 * @description
 * - Expected to be used inside a filter function for candidate lists.
 * - Returns `true` for inactive candidates (not in ACTIVE or HOLD state).
 * - Uses the first item in `matchExclusions` or generates a default one with `getCandidateModel`.
 * - Reads `excludeUntil` date:
 *   - If present and in the future, logs debug info and returns `false`.
 * - Otherwise, returns `true`.
 */
export default function evalCandidateMatchExclusion(
  candidate = {},
  index = 0,
  candidates = []
) {
  if (
    candidate.state !== STATE_ACTIVE &&
    candidate.state !== STATE_HOLD
  ) { return true; }
  const matchExclusions = (
    candidate.matchExclusions[0] ||
    getCandidateModel({ matchExclusion: true })
  );
  const { excludeUntil = '' } = matchExclusions;
  if (
    YES(excludeUntil) &&
    moment().isBefore(excludeUntil)
  ) {
    console.debug(`match-exclude:${candidate._name}`);
    return false;
  }
  return true;
}
